export default "__VITE_ASSET__s1knTig1__"